import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from '../Icon'

export const ListItem = ({text, data, handleClick, isIcon, classNameIcon}) => {

    const component = data?.component;
    const objectData = {};
    for (const property in data) {
        if(property !== "component"){
            objectData[property] = data[property];
        }
    }

    return (
            // rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
            <li onClick={(e) =>{handleClick(e)}} data-object={JSON.stringify(objectData)} className="">
                {isIcon && <Icon typeIcon="squareFill" size="6px" className={classNameIcon} />}
                {text && <div className="text" >{text}</div> }
                {component !== undefined && component}
            </li>
    );

};

ListItem.propTypes = {
    text: PropTypes.string.isRequired,
};